import { render, staticRenderFns } from "./EditClientAccount.vue?vue&type=template&id=1cdfcb24&scoped=true"
import script from "./EditClientAccount.vue?vue&type=script&lang=js"
export * from "./EditClientAccount.vue?vue&type=script&lang=js"
import style0 from "./EditClientAccount.vue?vue&type=style&index=0&id=1cdfcb24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdfcb24",
  null
  
)

export default component.exports